import { useQuery } from "@tanstack/react-query"
import type { AuthUser } from "../utils/auth"
import useAuth from "../utils/auth"
import { claims, customQueryKeys } from "../utils/constants"

async function getOrganizationId(
  getIdTokenClaims: () => Promise<AuthUser | undefined>
) {
  const tokenClaims = await getIdTokenClaims()
  return tokenClaims?.[claims.org] as string | undefined
}

export function useOrganizationId() {
  const { getIdTokenClaims, isAuthenticated } = useAuth()
  return useQuery({
    queryKey: [customQueryKeys.organization_id, getIdTokenClaims],
    queryFn: async () => (await getOrganizationId(getIdTokenClaims)) ?? null,
    enabled: isAuthenticated,
  })
}
